import {
    IActivateHomeworkSchoolDTOOut,
    IBookedHomeworkSchoolToCancel,
    IBookHomeworksSchoolDTOOut,
    IHomeworkSchoolSettingsDTOOut,
} from '../../interfaces/homework-school.interface';
import { PaymentStatusEnum } from './../../enums/payment-status.enum';

// settings
export class GetSchoolHomeworkSchoolSettings {
    public static readonly type = '[HomeworkSchool settings] get';
    constructor(public schoolId: number) {}
}

export class UpdateHomeworkSchoolSetting {
    public static readonly type = '[HomeworkSchool setting] update';
    constructor(public homeworkSchoolSetting: IHomeworkSchoolSettingsDTOOut) {}
}

// HomeworkSchool

export class ActivateHomeworkSchool {
    public static readonly type = '[HomeworkSchool] activate';
    constructor(public homeworkSchool: IActivateHomeworkSchoolDTOOut) {}
}

export class DisableHomeworkSchool {
    public static readonly type = '[HomeworkSchool] disable';
    constructor(public homeworkSchool: IActivateHomeworkSchoolDTOOut) {}
}

export class DisableHomeworkSchoolFullMonth {
    public static readonly type = '[HomeworkSchool] disable full month';
    constructor(public monthDate: Date) {}
}

export class GetAllAvailableHomeworkSchool {
    public static readonly type = '[HomeworkSchool] get all available';
}

export class ResetHomeworkSchoolData {
    public static readonly type = '[HomeworkSchool] reset data';
}

export class BookHomeworkSchool {
    public static readonly type = '[HomeworkSchool] book';
    constructor(public homeworkSchoolToBook: IBookHomeworksSchoolDTOOut) {}
}

export class GetBookedHomeworkSchool {
    public static readonly type = '[Booked HomeworkSchool] get';
    constructor(
        public payload: {
            from?: string;
            to?: string;
            search?: string;
            schoolId?: number;
            educationLevelId?: number;
            homeworkTypes?: number;
            paymentStatus?: PaymentStatusEnum[];
        },
        public isFilter?: boolean
    ) {}
}

export class CancelHomeworkSchoolBooking {
    public static readonly type = '[HomeworkSchool] cancel';
    constructor(public idsToCancel: IBookedHomeworkSchoolToCancel) {}
}

export class GetTotalOfBookedHomeworkPerMonth {
    public static readonly type = '[Homeworks] get total of booked meals per month';
}

export class ResetFilteredBookedHomeworks {
    public static readonly type = '[Homeworks] reset filtered homeworks';
}
